import { getPostLoginData } from "./getpostlogindata";

export const isEnterpriseSubscription = (): boolean => {
  const { user_info: userInfo } = getPostLoginData();
  const { account_tier: accountTier } = userInfo || {};
  const isEnterprise = accountTier === "ENT";

  return isEnterprise;
};
